import React from "react";

import Content from "../Content";
import { useWelshMap } from "../../useWelsh";
import { Link } from "gatsby";

const map = {
  english: {
    text1:
      "© Renewable Connections 2020. This website is owned by Renewable Connections Holdings Limited and is for informational purposes only. It does not constitute an offer or a solicitation to invest.",
    text2:
      "Renewable Connections Holdings Limited is registered in England and Wales (no. 12351952). The company's registered office is at 141-145 Curtain Road, 3rd Floor, London, EC2A 3BX.",
    text3:
      "Great House Energy Centre Limited is committed to respecting your privacy and to complying with UK data protection and privacy laws. Our |privacy policy| explains how we collect, use, share and protect personal information",
  },
  welsh: {
    text1:
      "© Renewable Connections 2020. Perchennog y wefan hon yw Renewable Connections Holdings Limited ac mae ar gyfer dibenion gwybodaeth yn unig. Nid yw'n ffurfio cynnig nac erfyniad i fuddsoddiad.",
    text2:
      "Mae Renewable Connections Holdings Limited wedi ei gofrestru yng Nghymru a Lloegr (rhif. 12351952). Cyfeiriad cofrestredig y cwmni yw 141-145 Curtain Road, 3rd Floor, London, EC2A 3BX.",
    text3:
      "Great House Energy Centre Limited is committed to respecting your privacy and to complying with UK data protection and privacy laws. Our |privacy policy| explains how we collect, use, share and protect personal information.",
  },
};

const Footer = () => {
  const text = useWelshMap(map);
  return (
    <Content color="blue">
      <p>{text.text1}</p>
      <p>{text.text2}</p>
      <p>
        {text.text3.split("|").map((x, j) =>
          j % 2 ? (
            <Link key={j} style={{ color: "white" }} to="/privacy-policy">
              {x}
            </Link>
          ) : (
            x
          )
        )}
      </p>
    </Content>
  );
};

export default Footer;
